import React, { Component } from 'react'
import styled from 'styled-components'
import { autobind } from 'core-decorators'
import Link from 'components/elements/link'
import breakPoints from 'themes/breakPoints'
import Logo from 'components/elements/logo-with-text'
import { fontWeight } from 'themes/font'
// import ChangeLanguage from '../change-language'
import PublicUrl from 'components/public-url'
import { inject, observer } from 'mobx-react'

import {
  Container,
  Collapse,
  Navbar as $Navbar,
  NavbarToggler,
  Nav,
  NavItem
} from 'reactstrap'

const Navbar = styled($Navbar)`
  background: ${props => (props.sticky ? '#fff' : 'transparent')};
  transition: all 0.2s ease-out;
  box-shadow: ${props => props.sticky ? '#00000021 0px 0px 24px 0px' : 'none'};
  z-index: 1050 !important;

  .tungtung-navbar-nav {
    &:hover {
      .nav-item:not(.nav-item-logo) {
        .nav-link {
          opacity: 0.3;
        }
      }
    }
    .nav-item:not(.nav-item-logo):hover {
      .nav-link {
        color: #000 !important;
        opacity: 1;
      }
    }
  }

  @media (max-width: ${breakPoints.md.max}px) {
    background: #fafbfb;
    .brandName {
      .product {
        display: ${props => (props.sticky ? 'block' : 'none')};
      }
    }
  }
  @media (min-width: ${breakPoints.lg.min}px) {
    min-height: ${props => (props.sticky ? 56 : 96)}px;
    .navbar-brand {
      margin: 0;
      padding: 0;
    }
    .navbar-nav {
      flex: 1;
      justify-content: space-evenly;
    }
    .nav-item {
      flex: 1;
      .nav-link {
        flex: 1;
        color: rgba(0,0,0,.5) !important;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        position: relative;
        color: #000 !important;
        font-weight: ${fontWeight.medium};
        /* font-size: ${props => props.sticky ? 14 : 16}px; */
        transition: all 0.2s linear;
        &.active {
          /* opacity: 0.3; */
          color: #0984E3 !important;
        }
        &:hover,
        &:focus,
        &.dropdown-toggle::after {
          color: #000;
        }
      }
      &.dashboard,
      &.auth {
        .nav-link {
          color: #0984E3 !important;
          display: flex;
          align-items: center;
          height: 40px;
          color: #fff !important;
          border-radius: 10px;
          background-color: #5AC23A;
          padding: 0px 16px;
        }
      }
    }
  }
`

const NavLink = styled(Link)`
  color: #fff;
`

@inject('authStore')
@observer
@autobind
class MenuContent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isOpen: false
    }
  }

  toggle () {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  render () {
    const { mode, menu, sticky, authStore } = this.props
    return (
      <Navbar mode={mode} expand='lg' light sticky={sticky ? 'true' : null}>
        <Container>
          <Link to='/' className='navbar-brand d-lg-none'>
            <Logo small={sticky} isSticky={sticky} />
          </Link>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className='ml-auto align-items-lg-center tungtung-navbar-nav' navbar>
              <NavItem className='d-none d-lg-flex nav-item-logo'>
                <Link to={'/'}>
                  <NavLink className='nav-link'>
                    <Logo
                      small={sticky}
                      isSticky={sticky}
                    />
                  </NavLink>
                </Link>
              </NavItem>
              {typeof window !== 'undefined' && menu.map((item, index) => {
                if (item.name === 'languages') {
                  // return <ChangeLanguage key={index} />
                  return null
                }
                if (item.link.indexOf('/dashboard') > -1) {
                  if (!authStore.isAuthenticated) return null
                  return (
                    <NavItem key={index} className='dashboard'>
                      <PublicUrl to={''}>
                        <NavLink className='nav-link' activeClassName='active'>
                          {item.name}
                        </NavLink>
                      </PublicUrl>
                    </NavItem>
                  )
                }
                if (item.link.indexOf('/auth') > -1) {
                  if (authStore.isAuthenticated) {
                    return null
                  }
                  return (
                    <NavItem key={index} className={item.link === '/auth/register' ? 'auth' : ''}>
                      <PublicUrl to={item.link}>
                        <NavLink className='nav-link' activeClassName='active'>
                          {item.name}
                        </NavLink>
                      </PublicUrl>
                    </NavItem>
                  )
                }
                return (
                  <NavItem key={index}>
                    <NavLink
                      to={item.link}
                      target='_blank'
                      className='nav-link'
                      activeClassName='active'
                    >
                      {item.name}
                    </NavLink>
                  </NavItem>
                )
              })}
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    )
  }
}

export default MenuContent
